<div class="search-not-found">
  <div class="not-found-content">
    @if (notFoundIcon) {
      <svg-icon class="not-found-icon" [src]="notFoundIcon"></svg-icon>
    }
    <span class="main-info">{{ mainInfoTranslationKey | translate }}</span>

    @if (!userAdviceDisabled) {
      <span class="user-advice">
        {{ userAdviceTranslationKey || buildTranslationKey('userAdvice') | translate }}
      </span>
    }

    @if (isBackButtonEnabled) {
      <div class="buttons">
        <app-new-button
          data-test-id="back-to-all-data-button"
          [size]="'responsive'"
          (click)="backToAllDataBtnClick.emit()"
        >
          {{ backToAllDataTranslationKey | translate }}
        </app-new-button>
        @if (isAdditionalActionEnabled) {
          <app-new-button [type]="'secondary'" (click)="additionalActionBtnClick.emit()">
            {{ additionalActionTranslationKey | translate }}
          </app-new-button>
        }
      </div>
    }
  </div>
</div>
